export default "__VITE_ASSET__1a98fe69__"